const getTrainerCard = (card, index, suited) => {
  if (suited || index === 1) {
    switch (card) {
      case "2": {
        return 14;
      }
      case "3": {
        return 15;
      }
      case "4": {
        return 16;
      }
      case "5": {
        return 17;
      }
      case "6": {
        return 18;
      }
      case "7": {
        return 19;
      }
      case "8": {
        return 20;
      }
      case "9": {
        return 21;
      }
      case "T": {
        return 22;
      }
      case "J": {
        return 23;
      }
      case "Q": {
        return 24;
      }
      case "K": {
        return 25;
      }
      case "A": {
        return 26;
      }
      default: {
        return null;
      }
    }
  } else {
    switch (card) {
      case "2": {
        return 40;
      }
      case "3": {
        return 41;
      }
      case "4": {
        return 42;
      }
      case "5": {
        return 43;
      }
      case "6": {
        return 44;
      }
      case "7": {
        return 45;
      }
      case "8": {
        return 46;
      }
      case "9": {
        return 47;
      }
      case "T": {
        return 48;
      }
      case "J": {
        return 49;
      }
      case "Q": {
        return 50;
      }
      case "K": {
        return 51;
      }
      case "A": {
        return 52;
      }
      default: {
        return null;
      }
    }
  }
};

const ExpressoTrainerPositions = ["BU", "SB", "BB"];
const ShotHandedTrainerPositions = ["LJ", "HJ", "CO", "BU", "SB", "BB"];

const getTrainerSeatName = (game, heroPosition, placeAfterHero) => {
  let positions =
    game === "exp" ? ExpressoTrainerPositions : ShotHandedTrainerPositions;
  let heroIndex = positions.indexOf(heroPosition);
  let vilainIndex = heroIndex + placeAfterHero;
  if (vilainIndex >= positions.length) {
    vilainIndex = vilainIndex - positions.length;
  }
  return positions[vilainIndex];
};

const hasPlayerFolded = (
  game,
  situation,
  heroPosition,
  vilainPosition,
  placeAfterHero
) => {
  let positions =
    game === "exp" ? ExpressoTrainerPositions : ShotHandedTrainerPositions;
  let heroIndex = positions.indexOf(heroPosition);
  let playerIndex = heroIndex + placeAfterHero;
  if (playerIndex >= positions.length) {
    playerIndex = playerIndex - positions.length;
  }
  if (situation === "callpush") {
    let vilainIndex = positions.indexOf(vilainPosition);
    if (playerIndex < heroIndex && playerIndex > vilainIndex) {
      // player after vilain and before hero
      return true;
    }
    if (playerIndex < vilainIndex) {
      // player before vilain
      return true;
    }
  } else {
    //open push
    if (playerIndex < heroIndex) {
      // player after vilain and before hero
      return true;
    }
  }
  return false;
};
export { hasPlayerFolded, getTrainerSeatName, getTrainerCard };
